import { useRef } from "react";

/**
 * @returns {{
 * notifyObserverListeners: (function(...[*]): any[]),
 * removeObserverListener: (function(*=): void),
 * addObserverListener: (function(*): void)
 * }}
 */
export const useObserverPattern = () => {
  const refListeners = useRef([]);

  const addListener = (listener) => {
    refListeners.current = [...refListeners.current, listener];
  };

  const removeListener = (listener) => {
    refListeners.current = refListeners.current.filter((oldListener) => oldListener !== listener);
  };

  const notifyListeners = (...args) => {
    const results = [];

    for (let listener of refListeners.current) {
      if (typeof listener === "function") {
        results.push(listener(...args));
      } else {
        results.push(undefined);
        removeListener(listener);
      }
    }

    return results;
  };

  return {
    addObserverListener: addListener,
    removeObserverListener: removeListener,
    notifyObserverListeners: notifyListeners
  };
};
